import { FC } from "react";
import { useTranslation } from "react-i18next";
import { track } from "@amplitude/analytics-browser";
import { InfoIcon } from "src/assets/Icons";

const FareRulesTrigger: FC<{ onOpen: () => void }> = ({ onOpen }) => {
  const { t } = useTranslation();

  return (
    <div className="flex p-1">
      <button
        onClick={() => {
          onOpen();
          track("Farerules Viewed");
        }}
        className="text-font-active flex cursor-pointer items-center gap-1 p-2 text-sm font-semibold"
      >
        <InfoIcon /> {t("Flights.details.fareRules.viewFareRules")}
      </button>
    </div>
  );
};

export default FareRulesTrigger;
